import Vue from "vue";

Vue.config.errorHandler = error => {
  console.error("[vue]", error);
  Vue.notify({
    group: "error",
    title: "[Vue] Error",
    text: error.message
  });
};

window.onerror = function(message, source, lineno, colno, error) {
  // Handling Uncaught Errors
  // Vue 프레임웤에 감지되지 않는 User가 일부러 내는 에러들
  console.error("[win]", error);
  Vue.notify({
    group: "error",
    title: "[Window] Error",
    text: error.message
  });
};
